import React from 'react';
import { ListReplyWrapper, ListReplyText } from './MessageListReply.styled';

type MessageButtonReplyProps = { title?: string };

export function MessageButtonReply({ title }: MessageButtonReplyProps) {
  if (!title) return null;
  return (
    <ListReplyWrapper>
      <span>↩</span>
      <ListReplyText>{title}</ListReplyText>
    </ListReplyWrapper>
  );
}
